import { createListenerMiddleware } from '@reduxjs/toolkit';
import Config from '../../Config';
import {
    getAvailableVersions,
    isNewVersion,
    startGuideTour,
    startTourWalkThrough,
    stopGuideTour,
    updateVersion,
} from './service';
import { preloadTourScript } from './loader';
import {
    fetchTourVersions,
    fetchTourVersionsFailed,
    fetchTourVersionsSuccess,
    loadTourScript,
    startTour,
    startTourFailed,
    startWalkThrough,
    startWalkThroughFailed,
    stopTour,
} from './slice';

const TOUR_SCRIPT_SRC = `${Config.guideTourUrl}/guidetour.js`;

export const tourListenerMiddleware = createListenerMiddleware();

tourListenerMiddleware.startListening({
    actionCreator: loadTourScript,
    effect: async (action, listenerApi) => {
        try {
            console.log('[GuideTour] Script loading', TOUR_SCRIPT_SRC);
            await preloadTourScript(TOUR_SCRIPT_SRC);
            console.log('[GuideTour] Script loaded & ready');

            if (!isNewVersion()) return;

            updateVersion();
            // detect service worker updated
            if (sessionStorage.getItem('sw-updated') === 'true') {
                sessionStorage.removeItem('sw-updated'); // reset flag
                console.log(
                    '[GuideTour] Detected swUpdated from sessionStorage'
                );
                listenerApi.dispatch(startTour());
            }
        } catch (err: any) {
            console.error('[Tour] Preload failed', err);
            listenerApi.dispatch(startTourFailed({ error: err.message }));
        }
    },
});

tourListenerMiddleware.startListening({
    actionCreator: startTour,
    effect: async (action, listenerApi) => {
        try {
            console.log('[GuideTour] Start tour', action.payload);
            await preloadTourScript(TOUR_SCRIPT_SRC); // Ensures it's loaded
            startGuideTour(action.payload?.version, action.payload?.forceStart);
        } catch (err: any) {
            console.error('[GuideTour] Start tour failed', err);
            listenerApi.dispatch(
                startTourFailed({
                    error: err.message,
                })
            );
        }
    },
});

tourListenerMiddleware.startListening({
    actionCreator: stopTour,
    effect: async (action, listenerApi) => {
        try {
            console.log('[GuideTour] Stop tour');
            stopGuideTour();
        } catch (err: any) {
            console.error('[GuideTour] Stop tour failed', err);
        }
    },
});

tourListenerMiddleware.startListening({
    actionCreator: fetchTourVersions,
    effect: async (action, listenerApi) => {
        try {
            console.log('[GuideTour] Fetch tour versions');
            await preloadTourScript(TOUR_SCRIPT_SRC); // Ensures it's loaded
            const versions = await getAvailableVersions();
            listenerApi.dispatch(fetchTourVersionsSuccess({ versions }));
        } catch (err: any) {
            console.error('[GuideTour] Fetch tour versions failed', err);
            listenerApi.dispatch(
                fetchTourVersionsFailed({
                    error: err.message,
                })
            );
        }
    },
});

tourListenerMiddleware.startListening({
    actionCreator: startWalkThrough,
    effect: async (action, listenerApi) => {
        try {
            console.log('[GuideTour] Start walk-through', action.payload);
            await preloadTourScript(TOUR_SCRIPT_SRC); // Ensures it's loaded
            startTourWalkThrough(action.payload?.forceStart);
        } catch (err: any) {
            console.error('[GuideTour] Start walk-through failed', err);
            listenerApi.dispatch(
                startWalkThroughFailed({
                    error: err.message,
                })
            );
        }
    },
});
